import type { Ref } from "vue";

import {
  calendarColorSource,
  EVENT_COLOR_SOURCE_STORAGE_KEY,
  TASK_COLOR_SOURCE_STORAGE_KEY,
  type ColorSource,
} from "@/components/graph/calendarColorSource";
import { useBrowserStore } from "@/composables/useBrowserStore";
import { type UseProfile } from "@/composables/useProfile";

/**
 * Account-scoped color-source prefs (Calendars settings), stored as tagged
 * {@link ColorSource} values. The caller owns the returned state
 * (`releaser.add(useCalendarColorSources(profile))`).
 */
export function useCalendarColorSources(profile: Ref<UseProfile>): {
  events: Ref<ColorSource>;
  tasks: Ref<ColorSource>;
  release: () => void;
} {
  const { syncState } = useBrowserStore(profile.value.user.accountId);
  const events = syncState(
    EVENT_COLOR_SOURCE_STORAGE_KEY,
    calendarColorSource()
  );
  const tasks = syncState(TASK_COLOR_SOURCE_STORAGE_KEY, calendarColorSource());
  return {
    events,
    tasks,
    release: () => {
      events.release();
      tasks.release();
    },
  };
}
